export class ScriptLoaderService {
  private basePath: string;

  constructor(basePath: string) {
    this.basePath = basePath;
  }

  loadScript(src: string): Promise<void> {
    return new Promise((resolve, reject) => {
      if (document.querySelector(`script[src="${src}"]`)) return resolve();
      const script = document.createElement('script');
      script.src = src;
      script.onload = () => resolve();
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  loadCss(href: string): Promise<void> {
    return new Promise((resolve, reject) => {
      if (document.querySelector(`link[href="${href}"]`)) return resolve();
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = href;
      link.onload = () => resolve();
      link.onerror = reject;
      document.head.appendChild(link);
    });
  }

  isAngularJsLoaded(): boolean {
    return !!window.angular && !!window.angular.version;
  }

  isUiGridLoaded(): boolean {
    let isLoaded = false;
    try {
      isLoaded = !!window.angular && !!window.angular.module('ui.grid');
    } catch (e) {
      //ignore
    }
    return isLoaded;
  }

  async loadAngularJs(): Promise<void> {
    try {
      await this.loadScript(`${this.basePath}/angular/angular.min.js`);
    } catch (e) {
      console.error('Error loading AngularJS script:', e);
    }
  }

  async loadAngularUiGrid(): Promise<void> {
    try {
      await this.loadScript(`${this.basePath}/angular-ui-grid/ui-grid.min.js`);
      await this.loadCss(`${this.basePath}/angular-ui-grid/ui-grid.min.css`);
    } catch (e) {
      console.error('Error on loading UI-Grid scripts:', e);
    }
  }

  async loadAngularJsAndUiGridIfNeeded(): Promise<void> {
    if (!this.isAngularJsLoaded()) {
      await this.loadAngularJs();
    }

    if (!this.isUiGridLoaded()) {
      await this.loadAngularUiGrid();
    }
    return Promise.resolve();
  }
}
